import { LOCALES, useI18n, type Locale } from '@apis/i18n';
import { SegmentedControl } from '@apis/ui';

/** ID / EN toggle (Indonesian is the default UI language). */
export function LanguageSwitch() {
  const { t, locale, setLocale } = useI18n();
  return (
    <SegmentedControl<Locale>
      ariaLabel={t('common.language')}
      value={locale}
      onChange={setLocale}
      options={[...LOCALES]
        .reverse()
        .map((l) => ({ value: l, label: <span lang={l}>{t(`common.languageShort.${l}`)}</span> }))}
    />
  );
}
